











































import {
  Vue,
  Component,
  Watch
} from "@/shared/vuepack";
import OutageNotificationBanner from "@/shared/components/OutageNotificationBanner.vue";
import Notifier from "@/shared/components/Notifier.vue";
import OnboardingHeader from "@/shared/components/OnboardingHeader.vue";
import Header from "@/employer/components/shared/Header.vue";
import Footer from "@/employer/components/shared/Footer.vue";
import Nav from "@/employer/components/shared/Nav.vue";
import MainNavigation from "@/employer/components/shared/MainNavigation.vue";
import { LoginRouteNames } from "@/shared/loginRoutes";
import * as RouteNames from "@/employer/route-names";
import {
  isPartnerPage,
  isCustomerServicePage
} from "@/employer/navSelector";
import DatadogScript from "@/shared/components/DatadogScript.vue";
import { useUserStore } from "@/shared/store/user";
import { useNavigationStore } from "@/shared/store/navigation";
import { useThemeStore } from "@/shared/store/theme";
import router from "@/employer/routes";
import { hsabBankBalanceWatch } from "@/shared/hsabInvestmentBalanceWatch";
import { useRootStore } from "@/shared/store/root";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import _ from "lodash";
import Flagging from "@/shared/flagging";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";

@Component({
  components: {
    OnboardingHeader,
    Header,
    Nav,
    MainNavigation,
    Notifier,
    Footer,
    DatadogScript,
    OutageNotificationBanner
  }
})
export default class App extends Vue {
  userStore = useUserStore();
  navigationStore = useNavigationStore();
  themeStore = useThemeStore();
  rootStore = useRootStore();
  portalCustomizationStore = usePortalCustomizationStore();
  featureFlagStore = useFeatureFlagStore();

  isInWizard?: boolean = null;
  wizardStepNumber = 0;
  hideProgressIndicator = true;

  created () {
    this.rootStore.setupRoot();
    Flagging.initialize();
    hsabBankBalanceWatch();

    this.registerActivity = _.throttle(this.registerActivity, 15000).bind(this);
    this.userStore.startAutologoutTimer();
    if (this.userStore.loggedIn) {
      this.featureFlagStore.setUserContext({ email: this.userStore.email });
    }
  }

  registerActivity () {
    this.userStore.activeUserPing();
  }

  mounted () {
    this.watchRoute(this.$route, null);
  }

  get isPartnerHomeHeaderVisible () {
    return this.partnerHeaderMode.showCustomerServiceHeader
        || this.partnerHeaderMode.showEmployerNameHeader;
  }

  get hideAllHeaders () {
    return this.hideHeadersRoute || this.$route.meta["full-render-main-component"];
  }

  get hideHeadersRoute (): boolean {
    const hideHeaders = [
      RouteNames.Signup,
      LoginRouteNames.Login,
      LoginRouteNames.MfaVerify,
      LoginRouteNames.ForgotPassword,
      LoginRouteNames.ForgotPasswordVerify,
      LoginRouteNames.UpdatePassword,
      RouteNames.Home
    ];
    return hideHeaders.includes(this.$route.name);
  }

  get showNav () {
    if (this.$route.meta["full-render-main-component"]) {
      return false;
    }

    if (this.$route.params.partnerId) {
      return true;
    }

    return this.userStore.loggedIn && this.userStore.employerOnboarded && !this.isInWizard && this.$route.name !==
        RouteNames.Home;
  }

  get showOnboardingHeader () {
    if (this.$route.params.partnerId) {
      return false;
    }

    return !this.userStore.employerOnboarded || this.isInWizard || this.$route.name === RouteNames.Home;
  }

  getRouteInformation (route) {
    const stepParam = parseInt(route.params.step);
    this.wizardStepNumber = isNaN(stepParam) ? 0 : stepParam;
    this.hideProgressIndicator = (route.name !== "onboarding" && route.name !== "signup");
  }

  @Watch("$route")
  watchRoute (newRoute, oldRoute) {
    if (this.isInWizard === null && oldRoute && oldRoute.fullPath) {
      this.isInWizard = oldRoute.fullPath.startsWith("/onboarding/");
    }

    if (newRoute && newRoute.fullPath) {
      this.isInWizard = newRoute.fullPath.startsWith("/onboarding/");
      this.getRouteInformation(newRoute);

      if (this.userStore.loggedIn) {
        // Attempt to retrieve partner support info each route change in case it hasn't been loaded yet, or the call
        // did not succeed previously.
        this.portalCustomizationStore.getSupportInfo(
          { partnerId: this.portalCustomizationStore.partnerId, employerId: this.userStore.employerId });
      }
      // User is not logged in -- make attempt to parse partner from query string to load partner support info
      else {
        const partnerId = (newRoute.query && (newRoute.query.partnerid || newRoute.query.partner)) ?
          newRoute.query.partnerid || newRoute.query.partner : this.portalCustomizationStore.partnerId;

        const parsedPartnerId = _.toSafeInteger(partnerId);

        this.portalCustomizationStore.getSupportInfo({ partnerId: parsedPartnerId, employerId: 0 });
      }
    }
  }

  get partnerHeaderMode () {
    const showCustomerServiceHeader = isCustomerServicePage(this.$route.name);
    const showEmployerNameHeader = !showCustomerServiceHeader && this.userStore.partnerId &&
        !isPartnerPage(this.$route.name);
    return {
      showCustomerServiceHeader,
      showEmployerNameHeader: !!showEmployerNameHeader
    };
  }
}
